import { IHeroForEarlyStage as IContentfulHeroForEarlyStage } from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { HeroForEarlyStage } from 'marketing-site/src/library/components/HeroForEarlyStage'
import {
  HeroWithCTA,
  IProps as IHeroWithCTA,
} from 'marketing-site/src/library/components/HeroWithCTA'
import React from 'react'
import { transformAddonPricingModal } from './ContentfulAddonPricingModal'
import { transformHeroWithCta } from './ContentfulHeroWithCTA'

export function ContentfulHeroForEarlyStage(heroForEarlyStage: IContentfulHeroForEarlyStage) {
  function renderHero(isEarlyStage: boolean, earlyStagePartnerName: string | undefined) {
    const heroProps = transformHeroWithCta(heroForEarlyStage.fields.hero)

    return (
      <HeroWithCTA
        {...heroProps}
        subheading={getSubheading(isEarlyStage, earlyStagePartnerName, heroProps)}
      />
    )
  }

  return (
    <EntryMarker entry={heroForEarlyStage}>
      {() => (
        <HeroForEarlyStage
          {...transformHeroForEarlyStage(heroForEarlyStage)}
          renderHero={renderHero}
        />
      )}
    </EntryMarker>
  )

  function getSubheading(
    isEarlyStage: boolean,
    earlyStagePartnerName: string | undefined,
    heroProps: IHeroWithCTA,
  ) {
    if (isEarlyStage) {
      if (earlyStagePartnerName === 'websummit2021') {
        return 'Eligible startups that attended Web Summit get advanced Intercom features and Early Stage Academy at a 100% discount.'
      } else {
        return heroForEarlyStage.fields.subheadingForEarlyStagePartners
      }
    } else {
      return heroProps.subheading
    }
  }
}

export function transformHeroForEarlyStage({ fields }: IContentfulHeroForEarlyStage) {
  return {
    ...fields,
    earlyStageModal: fields.earlyStageModal && transformAddonPricingModal(fields.earlyStageModal),
  }
}
